import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {CommonService} from '../../../services/common.service';

interface User {
    id: number;
    mobile: string;
    email: string;
}

@Component({
    selector: 'app-email-info-dialog',
    templateUrl: './email-info-dialog.component.html',
    styleUrls: ['./email-info-dialog.component.scss']
})
export class EmailInfoDialogComponent implements OnInit {
    subject: any;
    emails: any;
    htmlContent: any;
    editorStyle: any;
    title;
    notAnsweredEmails: string;
    completedEmails: string;
    mode: string;
    users: User[] = [];
    selectedCategoryParentCategory;
    isLoading = false;
    parentCategories = [{id: 1, label: 'Συπλήρωσαν'}, {id: 2, label: 'Δεν απάντησαν'}];

    constructor(public dialogRef: MatDialogRef<EmailInfoDialogComponent>, public toastMessagesService: ToastMessagesService,
                private commonService: CommonService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.editorStyle = {height: '300px', width: '100%'};
        this.title = data.title;
        if (data.mode && data.mode === 'affirmations') {
            this.mode = data.mode;
            this.notAnsweredEmails = data.notAnswered;
            this.completedEmails = data.completed;
        } else {
            this.emails = data.emails ? data.emails : '';
        }
        this.subject = data.subject ? data.subject : '';
    }

    async ngOnInit() {
        this.subject = this.subject ? this.subject : '';
        this.emails = this.emails ? this.emails : '';
        this.htmlContent = '';
        // await this.initParentContactInfo();
        // this.dialogRef.updateSize('100%', '100%');
    }

    async initParentContactInfo() {
        try {
            this.isLoading = true;
            console.log(this.emails);
            if (this.emails) {
                const emails = this.emails.split(';');
                console.log(emails);
                for (const email of emails) {
                    const request: any = await this.commonService.insertItem(`people/parentByEmail`, {email});
                    console.log(request);
                }
            }
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
        }
    }

    close() {
        this.dialogRef.close();
    }

    formInvalid() {
        if (this.mode === 'affirmations') {
            return !(this.emails && this.subject && this.selectedCategoryParentCategory && this.htmlContent);
        } else {
            return !(this.emails && this.subject && this.htmlContent);
        }
    }

    sendEmail() {
        const tempEmails = this.emails.split(';');
        let valid = false;
        for (const email of tempEmails) {
            if (this.validateEmail(email.trim()) === false) {
                this.toastMessagesService.toastErrorMessage(`Ελέγξτε την μορφή των emails και δοκιμάστε ξανά`);
                valid = false;
                break;
            } else {
                valid = true;
            }
        }

        if (valid) {
            this.dialogRef.close({subject: this.subject, emails: this.emails, message: this.htmlContent});
        }
    }

    validateEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    async parentCategoriesChanged() {
        this.emails = this.selectedCategoryParentCategory.id === 1 ? this.completedEmails : this.notAnsweredEmails;
        // await this.initParentContactInfo();
    }
}
